import React from 'react';

// Types de statuts
export enum StatusType {
  // Page
  PAGE_NOT_VISITED = 'page_not_visited',
  PAGE_VISITED = 'page_visited',
  
  // Quiz
  QUIZ_NOT_STARTED = 'quiz_not_started',
  QUIZ_VISIBLE = 'quiz_visible',
  QUIZ_STARTED = 'quiz_started',
  QUIZ_IN_PROGRESS = 'quiz_in_progress',
  QUIZ_COMPLETED = 'quiz_completed',
  
  // Rendez-vous
  NO_APPOINTMENT = 'no_appointment',
  APPOINTMENT_SCHEDULED = 'appointment_scheduled'
}

// Configuration des badges
const badgeConfig = {
  [StatusType.PAGE_NOT_VISITED]: {
    label: 'Page non visitée',
    className: 'bg-gray-100 text-gray-800',
    dotClassName: 'bg-gray-400',
    showDot: true
  },
  [StatusType.PAGE_VISITED]: {
    label: 'Page visitée',
    className: 'bg-green-100 text-green-800',
    dotClassName: 'bg-green-500',
    showDot: true
  },
  [StatusType.QUIZ_NOT_STARTED]: {
    label: 'Quiz non commencé',
    className: 'bg-gray-100 text-gray-800',
    dotClassName: 'bg-gray-400',
    showDot: true
  },
  [StatusType.QUIZ_VISIBLE]: {
    label: 'Quiz visible',
    className: 'bg-gray-100 text-gray-800',
    dotClassName: 'bg-gray-400',
    showDot: true
  },
  [StatusType.QUIZ_STARTED]: {
    label: 'Quiz démarré',
    className: 'bg-green-100 text-green-800',
    dotClassName: 'bg-green-500',
    showDot: true
  },
  [StatusType.QUIZ_IN_PROGRESS]: {
    label: 'Quiz en cours',
    className: 'bg-yellow-100 text-yellow-800',
    dotClassName: 'bg-yellow-500',
    showDot: true
  },
  [StatusType.QUIZ_COMPLETED]: {
    label: 'Quiz terminé',
    className: 'bg-green-100 text-green-800',
    dotClassName: 'bg-green-500',
    showDot: true
  },
  [StatusType.NO_APPOINTMENT]: {
    label: 'Pas de RDV',
    className: 'bg-gray-100 text-gray-800',
    dotClassName: 'bg-gray-400',
    showDot: true
  },
  [StatusType.APPOINTMENT_SCHEDULED]: {
    label: 'RDV planifié',
    className: 'bg-green-100 text-green-800',
    dotClassName: 'bg-green-500',
    showDot: true
  }
};

// Fonctions helper pour obtenir le bon statut à partir des données
export const getPageStatus = (pageViewed: boolean): StatusType => {
  return pageViewed ? StatusType.PAGE_VISITED : StatusType.PAGE_NOT_VISITED;
};

export const getQuizStatus = (
  hasToken: boolean,
  quizStarted: boolean,
  quizInProgress: boolean,
  quizCompleted: boolean
): StatusType => {
  if (quizCompleted) return StatusType.QUIZ_COMPLETED;
  if (quizInProgress) return StatusType.QUIZ_IN_PROGRESS;
  if (quizStarted) return StatusType.QUIZ_STARTED;
  if (hasToken) return StatusType.QUIZ_VISIBLE;
  return StatusType.QUIZ_NOT_STARTED;
};

export const getAppointmentStatus = (hasAppointment: boolean): StatusType => {
  return hasAppointment ? StatusType.APPOINTMENT_SCHEDULED : StatusType.NO_APPOINTMENT;
};

interface StatusBadgeProps {
  type: StatusType;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ type, className = '' }) => {
  const config = badgeConfig[type];
  
  return (
    <div className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-all duration-200 hover:shadow-sm ${config.className} ${className}`}>
      {config.showDot && (
        <span className={`inline-block w-2 h-2 rounded-full mr-2 transition-all duration-300 ${config.dotClassName}`} />
      )}
      <span>{config.label}</span>
    </div>
  );
};

export default StatusBadge;